// NATIVE
import * as React from 'react';

// INSTALLED
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

// CUSTOM
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../../../../components/SnackAlert';
import { storeCreateDevice } from '../../../../../store/ratings';
import MultipleSnackbars from '../../../../../components/MultipleSnackbars';
import { CreateDevice } from '../crear/CreateDevice';
import { closeSessionGlobal } from '../../../../../commons/utils';
import { timeToClosedToast } from '../../../../../commons/values';
import { ModalSessionExpired } from '../../../../../components/generics/ModalSessionExpired';
import validationSchema from '../formModels/crear/validationSchema';
import formInitialValues from '../formModels/crear/formInitialValues';
import createDeviceFormModel from '../formModels/crear/createDeviceFormModel';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const DialogRatingsDevice = (props: any) => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // USE STATE
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_device, setPercentajeDevice] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [txtBtnDevice, setTxtBtnDevice] = React.useState<string>('Crear Dispositivo');

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  // PROPS
  const { open, handleCloseModalCrear } = props;

  // DATA MODELS
  const { formId, formField } = createDeviceFormModel;
  const currentValidationSchema = validationSchema[0];

  //  USE EFFECT
  React.useEffect(() => {
    setIsSubmiting(!open);
  }, [props]);

  // CONST FUNCTIONS
  const handleClose = () => {
    handleCloseModalCrear(false);
  };

  const _handleSubmit = async (values: any, actions: any) => {
    setTxtBtnDevice('Un Momento...');
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const usersValue = values[formField.users.name];
    const usersIds = Array.isArray(usersValue)
      ? usersValue.map((u: any) => u.value || u)
      : usersValue
        ? [usersValue.value || usersValue]
        : [];

    const { logo_device_preview, logo_quality_preview, ...cleanValues } = values;

    const valuesToSend = {
      ...cleanValues,
      [formField.is_user_required.name]: values[formField.is_user_required.name] ? 1 : 0,
      [formField.is_single_user.name]: values[formField.is_single_user.name] ? 1 : 0,
      [formField.is_multi_user.name]: values[formField.is_multi_user.name] ? 1 : 0,
      [formField.all_users.name]: values[formField.all_users.name] ? 1 : 0,
      [formField.users.name]: usersIds,
    };

    const response = await dispatch(storeCreateDevice(valuesToSend, setPercentajeDevice));

    await setTxtBtnDevice('Crear Dispositivo');

    const result = await validateResponseCreate(response, ' ( Crear Dispositivo ) ');

    if (response.code == 409) {
      setIsSubmiting(false);
    }

    if (!result) {
      return false;
    }

    setIsSubmiting(false);

    if (response.ok) {
      const errors: any = {
        msg: 'Dispositivo Creado Con Exito',
        status: 'success',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.setSubmitting(false);
      handleCloseModalCrear(false);
    }
  };

  const validateResponseCreate = async (response: any, textActionConcat: string) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      await handleCloseModalCrear(false);
      setModalSessionExpired(true);
      return false;
    }

    // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION
    if (!response.ok && response.code == 403) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 403 EL DATO YA SE ENCUENTRA REGISTRADO
    if (!response.ok && response.code == 409) {
      const errors: any = {
        msg: response.errors + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = [];

      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element,
        });
      });

      setMessagesAlerts(errors);
      return false;
    }

    return true;
  };

  return (
    <React.Fragment>
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontWeight: 700, display: 'flex', alignItems: 'center' }}
          id="detail-dialog-title"
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: 'rgba(105, 108, 255, 0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 2,
              color: '#696cff',
            }}
          >
            <SaveOutlinedIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#32475CDE', lineHeight: 1.2 }}>
              Crear Dispositivo de Calificación
            </Typography>
            <Typography variant="body2" sx={{ color: '#32475C99', mt: 0.5 }}>
              Crear información del dispositivo de calificación
            </Typography>
          </Box>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              <>
                <Form id={formId}>
                  <CreateDevice formField={formField} />

                  <Button
                    disabled={isSubmiting}
                    style={{ margin: 5, float: 'right' }}
                    type="submit"
                    variant="contained"
                    color={'primary'}
                  >
                    {txtBtnDevice}
                  </Button>
                </Form>
              </>
            </Formik>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
